module.exports = __webpack_public_path__ + "img/cover.8de41c85.gif";